export const products = {
  phones: [
    // iPhone 17 Series
    {
      id: 'iph17pm',
      name: 'iPhone 17 Pro Max 256GB',
      price: 840000,
      brand: 'Apple',
      series: '17 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Titanium Design • A19 Pro',
      description: 'The upcoming pinnacle of iPhone technology.'
    },
    {
      id: 'iph17air',
      name: 'iPhone 17 Air 256GB',
      price: 650000,
      brand: 'Apple',
      series: '17 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Ultra-thin • A19 Bionic',
      description: 'Revolutionary slim design.'
    },
    // iPhone 16 Series
    {
      id: 'iph16sealed',
      name: 'iPhone 16 Sealed',
      price: 690000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch?wid=512&hei=512&fmt=png-alpha',
      specs: 'Brand New • Sealed Box',
      description: 'The latest standard iPhone.'
    },
    {
      id: 'iph16open',
      name: 'iPhone 16 Open Box',
      price: 585000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch?wid=512&hei=512&fmt=png-alpha',
      specs: 'Open Box • Mint Condition',
      description: 'Like new, amazing value.'
    },
    {
      id: 'iph16plus128',
      name: 'iPhone 16 Plus 128GB',
      price: 480000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB • A18 Chip',
      description: 'Powerful performance, larger display.'
    },
    {
      id: 'iph16pm256',
      name: 'iPhone 16 Pro Max 256GB',
      price: 850000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-7inch-blacktitanium?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Titanium Design • A18 Pro',
      description: 'The pinnacle of iPhone performance.'
    },
    {
      id: 'iph16p256',
      name: 'iPhone 16 Pro 256GB',
      price: 780000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-pro-finish-select-202409-6-1inch-blacktitanium?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Titanium Design • A18 Pro',
      description: 'Pro performance in a compact size.'
    },
    {
      id: 'iph16-128',
      name: 'iPhone 16 128GB',
      price: 480000,
      brand: 'Apple',
      series: '16 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-16-finish-select-202409-6-1inch-black?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB • A18 Chip',
      description: 'Powerful and efficient.'
    },
    // iPhone 15 Series
    {
      id: 'iph15pm512',
      name: 'iPhone 15 Pro Max 512GB',
      price: 500000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '512GB • Titanium'
    },
    {
      id: 'iph15pm256',
      name: 'iPhone 15 Pro Max 256GB',
      price: 470000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Titanium'
    },
    {
      id: 'iph15p256',
      name: 'iPhone 15 Pro 256GB',
      price: 390000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch?wid=512&hei=512&fmt=png-alpha',
      specs: '256GB • Titanium'
    },
    {
      id: 'iph15p128',
      name: 'iPhone 15 Pro 128GB',
      price: 375000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-pro-finish-select-202309-6-1inch?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB • Titanium'
    },
    {
      id: 'iph15plus128',
      name: 'iPhone 15 Plus 128GB',
      price: 350000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-7inch?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB'
    },
    {
      id: 'iph15-128',
      name: 'iPhone 15 128GB',
      price: 300000,
      brand: 'Apple',
      series: '15 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-15-finish-select-202309-6-1inch?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB'
    },
    // iPhone 14 Series
    {
      id: 'iph14pm256',
      name: 'iPhone 14 Pro Max 256GB',
      price: 375000,
      brand: 'Apple',
      series: '14 series',
      image: 'https://www.apple.com/newsroom/images/product/iphone/standard/Apple-iPhone-14-Pro-iPhone-14-Pro-Max-hero-220907_Full-Bleed-Image.jpg.large.jpg',
      specs: '256GB'
    },
    {
      id: 'iph14pm128',
      name: 'iPhone 14 Pro Max 128GB',
      price: 360000,
      brand: 'Apple',
      series: '14 series',
      image: 'https://www.apple.com/newsroom/images/product/iphone/standard/Apple-iPhone-14-Pro-iPhone-14-Pro-Max-hero-220907_Full-Bleed-Image.jpg.large.jpg',
      specs: '128GB'
    },
    // ... many more iPhones follow the same pattern
    {
      id: 'iphxr128',
      name: 'iPhone XR 128GB',
      price: 100000,
      brand: 'Apple',
      series: 'XR series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone-xr-white-select-201809?wid=512&hei=512&fmt=png-alpha',
      specs: '128GB'
    },
    {
      id: 'iph11-64',
      name: 'iPhone 11 64GB',
      price: 110000,
      brand: 'Apple',
      series: '11 series',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/iphone11-black-select-2019?wid=512&hei=512&fmt=png-alpha',
      specs: '64GB'
    },

    // Samsung Series
    {
      id: 'sam_s25u512',
      name: 'Samsung S25 Ultra 512GB',
      price: 630000,
      brand: 'Samsung',
      series: 'S Series',
      image: 'https://images.samsung.com/is/image/samsung/p6pim/hk/2401/gallery/hk-galaxy-s24-s928-sm-s9280ztahko-thumb-539304381',
      specs: '512GB • AI Features'
    },
    {
      id: 'sam_s25u255',
      name: 'Samsung S25 Ultra 255GB',
      price: 540000,
      brand: 'Samsung',
      series: 'S Series',
      image: 'https://images.samsung.com/is/image/samsung/p6pim/hk/2401/gallery/hk-galaxy-s24-s928-sm-s9280ztahko-thumb-539304381',
      specs: '255GB'
    },
    {
      id: 'sam_a22',
      name: 'Samsung A22',
      price: 65000,
      brand: 'Samsung',
      series: 'A Series',
      image: 'https://images.samsung.com/is/image/samsung/p6pim/uk/sm-a225fzkgeua/gallery/uk-galaxy-a22-4g-sm-a225-sm-a225fzkgeua-thumb-482061247',
      specs: 'Reliable Everyday Phone'
    },

    // Google Pixel
    {
      id: 'pix8p256',
      name: 'Google Pixel 8 Pro 256GB',
      price: 260000,
      brand: 'Google',
      series: 'Pixel 8',
      image: 'https://lh3.googleusercontent.com/XU95IuK-OpxmB_Z1fB-v3S7C-2O2Z8v6W-0S-0S-0S-0S-0S-0S-0S-0S-0S-0S-0S=w256',
      specs: '256GB • Tensor G3'
    },
    {
      id: 'pix5-128',
      name: 'Google Pixel 5 128GB',
      price: 80000,
      brand: 'Google',
      series: 'Pixel 5',
      image: 'https://lh3.googleusercontent.com/XU95IuK-OpxmB_Z1fB-v3S7C-2O2Z8v6W-0S-0S-0S-0S-0S-0S-0S-0S-0S-0S-0S=w256',
      specs: '128GB'
    }
  ],

  laptops: [
    {
      id: 'mbp16-m4',
      name: 'MacBook Pro 16" M4',
      price: 3250000,
      brand: 'Apple',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/mbp16-spacegray-select-202301?wid=512&hei=512&fmt=png-alpha',
      specs: 'M4 Max • 48GB • 2TB',
      description: 'The ultimate professional machine.'
    },
    {
      id: 'mba13-m3',
      name: 'MacBook Air 13" M3',
      price: 1350000,
      brand: 'Apple',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/macbook-air-midnight-select-20220606?wid=512&hei=512&fmt=png-alpha',
      specs: 'M3 • 16GB • 256GB'
    }
  ],

  headsets: [
    {
      id: 'airp_max',
      name: 'AirPods Max',
      price: 450000,
      brand: 'Apple',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/airpods-max-select-silver-202011?wid=512&hei=512&fmt=png-alpha',
      specs: 'High-fidelity audio • Active Noise Cancellation'
    },
    {
      id: 'sony_xm5',
      name: 'Sony WH-1000XM5',
      price: 350000,
      brand: 'Sony',
      image: 'https://m.media-amazon.com/images/I/61mZTo+5QnL._AC_SX679_.jpg',
      specs: 'Industry leading noise cancellation'
    }
  ],

  tablets: [
    {
      id: 'ipad_pro_m4',
      name: 'iPad Pro 13" M4',
      price: 1250000,
      brand: 'Apple',
      image: 'https://store.storeimages.cdn-apple.com/4982/as-images.apple.com/is/ipad-pro-finish-select-202405-13inch-spaceblack-wifi_AV1?wid=512&hei=512&fmt=png-alpha',
      specs: 'M4 Chip • OLED Display'
    },
    {
      id: 'tab_s9u',
      name: 'Samsung Tab S9 Ultra',
      price: 850000,
      brand: 'Samsung',
      image: 'https://images.samsung.com/is/image/samsung/p6pim/uk/sm-x910nzaaeua/gallery/uk-galaxy-tab-s9-ultra-x910-sm-x910nzaaeua-thumb-537233682',
      specs: '14.6" Dynamic AMOLED • S Pen included'
    }
  ]
};

export const formatPrice = (price) => {
  return new Intl.NumberFormat('en-US').format(price) + ' FCFA';
};